module.exports = __webpack_public_path__ + "2201fe9cd898d51b4e2a4d990db760fa.MP3";